module.exports = __webpack_public_path__ + "img/file-minus.56b333ed.svg";